import { defineMessages } from 'react-intl'

export default defineMessages({
  appErrorMessage: {
    id: 'ErrorComponent.Generic.BadRequest.Title',
    defaultMessage: 'An error has occurred'
  },
  backToCatalog: {
    id: 'SpaceCatalogAppDetailsPage.BackCatalog',
    defaultMessage: 'Back to Catalog'
  },
  backToInstalled: {
    id: 'SpaceCustomAppEditPage.BackToApps',
    defaultMessage: 'Back to Installed Apps'
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  catalogApp: {
    id: 'SpaceAppsPage.AppCatalog.Details.CatalogApp',
    defaultMessage: 'Catalog App'
  },
  confirmAction: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteInputLabel',
    defaultMessage: 'Enter the name of the app to confirm this action:'
  },
  delete: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteApp',
    defaultMessage: 'Delete App?'
  },
  deleteButton: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteAppButton',
    defaultMessage: 'Delete App'
  },
  deleteConfirm: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteWarning',
    defaultMessage: 'You are about to delete the {appName} app.'
  },
  subMessage: {
    id: 'SpaceCustomAppEditPage.ConfirmDeleteSubMessage',
    defaultMessage: "This is an unrecoverable action, there's no going back! This app will be permanently deleted."
  },
  deleteSuccess: {
    id: 'SpaceCustomAppEditPage.AppDeleted',
    defaultMessage: 'Done! App deleted.'
  },
  installSuccess: {
    id: 'SpaceCatalogAppDetailsPage.InstallSuccessMessage',
    defaultMessage: 'Nice! Installation Successful.'
  },
  instanceExists: {
    id: 'SpaceAppsPage.AppCatalog.Details.CatalogAppInstanceExists',
    defaultMessage:
      'An instance exists in your current space.  Install if you wish to create an additional instance of this app.'
  },
  tryAgain: {
    id: 'TryAgain',
    defaultMessage: 'Try Again'
  },
  updateSuccess: {
    id: 'SpaceCustomAppEditPage.UpdateSuccess',
    defaultMessage: 'All set! App Settings Successfully Updated'
  },
  webHookUrl: {
    id: 'CatalogAppInstanceForm.WebHookURL',
    defaultMessage: 'Web Hook URL'
  }
})
